import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import "hammerjs";
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.local) {
    // Change this if you want the environment to be accessible over IP
    __webpack_public_path__ = "http://lvh.me:4200/";
}
else {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(function (err) { return console.log(err); });
